import { PermType } from "../models/tenancies";

export const PERM_TYPES: Array<PermType> = ["Read", "Write", "Create", "Delete"];
export const DEFAULT_SECTION = "groups";
export const TENANCY_REGEX = new RegExp("^/tenancies/[^/]+$");
